export enum MessagesMutations {
  RESET = "RESET",
  SET_MESSAGES = "SET_MESSAGES",
  SET_MESSAGES_READ = "SET_MESSAGES_READ",
  SET_MESSAGE = "SET_MESSAGE",
  SET_RECIPENTS = "SET_RECIPENTS",
  SET_UNREAD_MESSAGES = "SET_UNREAD_MESSAGES",
}
